import { Share } from 'react-native'

import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

const useShareHook = (message: string) => {
  const toast = useToast()
  const share = async () => {
    try {
      await Share.share({
        message,
      })
    } catch (error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    }
  }
  return { share }
}

export { useShareHook }
